import * as React from "react";

export const Chat = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill={props.color || '#51A2B5'}
      fillRule="evenodd"
      d="M16 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2m11-9H5C3.346 3 2 4.346 2 6v15a1 1 0 0 0 1.515.857l4.524-2.714A.997.997 0 0 1 8.554 19H19c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3"
      clipRule="evenodd"
    />
    <mask
      id="a"
      width={20}
      height={19}
      x={2}
      y={3}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "luminance",
      }}
    >
      <path
        fill={props.color == '#51A2B5' ? '#fff' : props.color}
        fillRule="evenodd"
        d="M16 12a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2m-4 0a1 1 0 1 1 0-2 1 1 0 0 1 0 2m11-9H5C3.346 3 2 4.346 2 6v15a1 1 0 0 0 1.515.857l4.524-2.714A.997.997 0 0 1 8.554 19H19c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#a)">
      <path fill={props.color || '#51A2B5'} d="M0 0h24v24H0z" />
    </g>
  </svg>
);

export default Chat;
